import axios from "axios";

var path = process.env.NODE_ENV === 'production' ? '' : '';

export const lookupDataHelper = {
    loadData: async function (file) {
        var data = [];
        await axios
        .get(`${path}/cached-files/${file}`)
        .then(response => {
            data = response.data; 
        });
        return data;
    }
};

